var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCandlestickChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_5722",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_5722)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 40V35.5H10V12.5H14V8H17V12.5H21V35.5H17V40H14ZM13 32.5H18V15.5H13V32.5ZM31 40V29.5H27V16.5H31V8H34V16.5H38V29.5H34V40H31ZM30 26.5H35V19.5H30V26.5Z",
    fill: "#0BAB47"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandlestickChart);
export default __webpack_public_path__ + "static/media/candlestick_chart.61dd6a9cb7ba3139829a4bf5ba83ffd2.svg";
export { ForwardRef as ReactComponent };